import axios from "axios";

import { BASE_URL, ROLES } from "../components/helpers/constants";
import {
  decryptPayload,
  getAccountArchivedMessage,
  getObjLength,
  handleExpiredSessionRedirect,
  isAccountArchivedApiResponse,
  shouldExpireSessionForApiStatus,
} from "../components/helpers/utils";

export const deleteAPIPayload = async (data) => {
  console.log("payload", data);
  let passingData = data.data === undefined ? {} : data.data;
  let device = decryptPayload(localStorage.getItem("isMobile"));

  // to identify logged in devices
  if (
    decryptPayload(localStorage.getItem("roles"))?.includes(ROLES.customer) ||
    decryptPayload(localStorage.getItem("roles"))?.includes(
      ROLES.professional
    ) ||
    decryptPayload(localStorage.getItem("path"))?.includes("create-account")
  ) {
    if (device) {
      passingData = { ...passingData, device_type: device };
    } else {
      passingData = { ...passingData, device_type: "web" };
    }
  }

  return await deleteAPICall(
    data.url,
    passingData,
    data.token,
    data?.brokertoken
  );
};

export const deleteAPICall = async (url, reqbody, token, brokertoken) => {
  return await axios
    .delete(`${BASE_URL}${url}`, {
      headers: {
        authorization: token
          ? `Bearer ${localStorage.getItem("authToken")}`
          : brokertoken
          ? `Bearer ${localStorage.getItem("agentauthToken")}`
          : null,
      },
    })
    .then(function (response) {
      console.log("in GetPayload deleteRequest...", response.data);
      return response.data;
    })
    .catch(function (error) {
      console.error("Error in deleteAPIPayloaddeleteRequest", error);
      let data = {
        success: false,
        error: error.message,
        data: error.response?.data,
      };
      const status = error.response?.status;
      const responseData = error.response?.data;
      if (shouldExpireSessionForApiStatus(status, responseData)) {
        handleExpiredSessionRedirect(window.location.pathname, {
          accountArchived: isAccountArchivedApiResponse(responseData),
          message: isAccountArchivedApiResponse(responseData)
            ? getAccountArchivedMessage(responseData)
            : undefined,
          responseData,
        });
      }
      return data;
    });
};
